import { render, staticRenderFns } from "./TreeViewEmployee.vue?vue&type=template&id=58589ac2&scoped=true"
import script from "./TreeViewEmployee.vue?vue&type=script&lang=js"
export * from "./TreeViewEmployee.vue?vue&type=script&lang=js"
import style0 from "./TreeViewEmployee.vue?vue&type=style&index=0&id=58589ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58589ac2",
  null
  
)

export default component.exports